import {AbstractControl} from "@angular/forms";

export function ValidateUrl(control: AbstractControl) {
  if (!control.value.startsWith('https://') && !control.value.startsWith('http://') && !control.value.startsWith('\\\\')) {
    return { validUrl: true };
  }
  return null;
}
